import { Injectable } from '@angular/core';

@Injectable()
export class DOMParserService {
  private selfclosingtags = [
    'area',
    'base',
    'br',
    'col',
    'embed',
    'hr',
    'img',
    'input',
    'link',
    'meta',
    'param',
    'source',
    'track',
    'wbr',
  ];
  constructor() {}

  toHTML(input: string) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(input, 'text/html');

    doc.body.innerHTML = doc.body.innerHTML.replace(/&nbsp;/g, '');

    let template = `
    <!DOCTYPE html>
    <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Document</title>
      </head>
      <body>
      ${doc.body.innerHTML}
      </body>
    </html>
    `;

    template = template.replace(/<(\w+)([^>]*)>/g, (match, tagName, rest) => {
      if (this.selfclosingtags.includes(tagName.toLowerCase())) {
        return `<${tagName}${rest} />`;
      }
      return match;
    });

    const OUT = template;
    return OUT;
  }

  getBody(input: string) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(input, 'text/html');

    console.log('doc.body.innerHTML: ', doc.body.innerHTML);
    return doc.body.innerHTML;
  }
}
